import React, { useState } from 'react';
import { Home, BookOpen, BarChart2, Wallet, User, LogOut, Gift } from 'lucide-react';
import usePermissionStore from '../../stores/permissionStore';
import { authService } from '../../services';

const FooterNav = ({ activeTab, onTabChange }) => {
  const { canAccessModule, isLoggedIn, user, role, logout } = usePermissionStore();
  const [loggingOut, setLoggingOut] = useState(false);

  // 获取角色显示名称
  const getRoleLabel = (role) => {
    const roleLabels = {
      admin: '管理员',
      teacher: '老师',
      student: '学生',
    };
    return roleLabels[role] || role;
  };

  // 处理登出
  const handleLogout = async () => {
    if (loggingOut) return;
    
    setLoggingOut(true);
    try {
      // 调用后端登出 API
      await authService.logout();
    } catch (error) {
      console.error('登出错误:', error);
    } finally {
      // 清除本地状态（authService.logout 已经调用了 apiClient.clearAuth 和 store logout）
      logout();
      setLoggingOut(false);
    }
  };

  return (
    <nav className="bg-white border-t border-[#EDF2F7] z-50">
      
      {/* 底部导航 */}
      <div className="h-[60px] flex justify-around items-center pb-2">
        {/* 首页 - 所有人都能访问 */}
        <button 
          onClick={() => onTabChange('home')}
          className={`flex flex-col items-center gap-1 w-16 ${activeTab === 'home' ? 'text-[#3182CE]' : 'text-[#CBD5E0]'}`}
        >
          <Home size={24} strokeWidth={activeTab === 'home' ? 2.5 : 2} />
          <span className="text-[10px] font-medium">首页</span>
        </button>
        
        {/* 教务 - 需要权限 */}
        {canAccessModule('students') && (
          <button 
            onClick={() => onTabChange('academic')}
            className={`flex flex-col items-center gap-1 w-16 ${activeTab === 'academic' ? 'text-[#3182CE]' : 'text-[#CBD5E0]'}`}
          >
            <BookOpen size={24} strokeWidth={activeTab === 'academic' ? 2.5 : 2} />
            <span className="text-[10px] font-medium">教务</span>
          </button>
        )}
        
        {/* 账务 - 需要权限 */}
        {canAccessModule('finance') && (
          <button 
            onClick={() => onTabChange('finance')}
            className={`flex flex-col items-center gap-1 w-16 ${activeTab === 'finance' ? 'text-[#3182CE]' : 'text-[#CBD5E0]'}`}
          >
            <Wallet size={24} strokeWidth={activeTab === 'finance' ? 2.5 : 2} />
            <span className="text-[10px] font-medium">账务</span>
          </button>
        )}
        
        {/* 报表 - 需要权限（管理员/老师） */}
        {canAccessModule('reports') && (
          <button 
            onClick={() => onTabChange('report')}
            className={`flex flex-col items-center gap-1 w-16 ${activeTab === 'report' ? 'text-[#3182CE]' : 'text-[#CBD5E0]'}`}
          >
            <BarChart2 size={24} strokeWidth={activeTab === 'report' ? 2.5 : 2} />
            <span className="text-[10px] font-medium">综合</span>
          </button>
        )}


      </div>
    </nav>
  );
};

export default FooterNav;
